// extracted by mini-css-extract-plugin
var _1 = "TeamButton-module__animateUploadProgressBarWidth--aV1Az";
var _2 = "TeamButton-module__animatedBackground--No6Yv";
var _3 = "TeamButton-module__isPopOverOpen--w91p_";
var _4 = "TeamButton-module__logoContainer--Ylho0";
var _5 = "TeamButton-module__orgName--C2j_D";
var _6 = "TeamButton-module__orgNameText--kD0Gb";
var _7 = "TeamButton-module__teamButton--i5eva";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "isPopOverOpen", _4 as "logoContainer", _5 as "orgName", _6 as "orgNameText", _7 as "teamButton" }
